module.exports = __webpack_public_path__ + "img/icon-notice.85adf2eb.svg";